import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupComponent } from '../../shared/popup/popup.component';

export type StatusType = 'error' | 'unknown' | 'success' | '';

export interface DialogData {
  status: StatusType;
  title: string;
  content: string;
  label: string;
  showStatusIcon: boolean;
}

@Component({
  selector: 'app-info-dialog',
  template: '<app-popup [showStatusIcon]="data.showStatusIcon" [status]="data.status" [title]="data.title" ' +
    '[content]="data.content" [label]="data.label"></app-popup>',
  imports: [
    PopupComponent,
  ],
})
export class InfoDialogComponent {
  readonly dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
}
